























































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';
import ProductCombobox from '@/components/Controls/ProductCombobox.vue';
import ProductContainerCombobox from '@/components/Controls/ProductContainerCombobox.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError', 'documents', 'forms', 'meta', 'warehouse_id', 'resort_date'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError,
    ...mapActions(STORE_KEY, ['addForm', 'removeForm'])
  },
  validations() {
    const rules: any = {
      $each: {
        product_id: { required },
        product_container_id: { required },
        from_product_id: {  },
        from_product_container_id: {  },
        quantity: { required },
        weight: { required },
        reasone: {  },
        client_id: { },
        deal_id: { },
        resort_type_id: {  },
      }
    }
    return {
      warehouse_id: {
        required
      },
      resort_date: {
        required
      },
      forms: rules
    }
  },
  components: {
    ProductCombobox,
    ProductContainerCombobox
  }
})
export default class WarehouseResortMultipleForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Boolean }) fileForm!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: Object }) group_key!: string;

  resortType: number = 1;
  resortTypes: any = {
    0: 'другое',
    1: 'пересорт',
    2: 'бой',
    3: 'срок годности',
    4: 'некондиция',
  }

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  // public warehouse_id: any = null;
  // public resort_date: any = null;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.group_key) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {initParams: this.initParams, group_key: this.group_key});
    } else {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    }
  }
  setResortType(index: number, resortType: any) {
    this.changeValue('resort_type_id', index, resortType)
    if (resortType > 0) {
      this.changeValue('reasone', index, this.resortTypes[resortType])
    } else {
      this.changeValue('reasone', index, '')
    }
  }

  changeValue(field: string, index: number, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, index, newValue: value
    });

    // @ts-ignore
    this.$v.forms.$each[index][field].$touch()
  }

  changeAllValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeAllValue`, {
      field, newValue: value
    });
  }

  saveFormData() {
    this.$v.forms.$touch()

    if(!this.$v.forms.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.forms.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }
  closeForm() {
    (this.$parent as any).close();
  }


  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

